import * as React from 'react';

export default (props) => {
  return (
    <svg width="24" height="24" viewBox="-2 -2 24 24">
      <g
        stroke={props.color || '#B5BFD2'}
        strokeWidth="2"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <path d="M3.5 10.478V8.144a7 7 0 1 1 7 7" />
        <path strokeLinejoin="round" d="M5.833 9.144l-2.333 2-2.333-2" />
      </g>
    </svg>
  );
};
